import axios from "axios";
const API_HOST = process.env.REACT_APP_API_HOST;

class Bank_Service {
  getAllBanks(user, page, search, pageLimit) {
    return axios({
      method: "get",
      url: `${API_HOST}/api/get-bank-name?page=${page}&pageSize=${pageLimit}&search=${search}`,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

  addBank(data, user) {
    return axios({
      method: "post",
      url: API_HOST + "/api/add-bank-name",
      data: data,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

  editBank(data, id, user) {
    return axios({
      method: "put",
      url: `${API_HOST}/api/bank-edit/${id}`,
      data: data,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

  manualBankEntryDeposit(id, data, user) {
    return axios({
      method: "post",
      url: `${API_HOST}/api/admin/add-bank-balance/${id}`,
      data: data,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

  manualBankEntryWithdraw(id, data, user) {
    return axios({
      method: "post",
      url: `${API_HOST}/api/admin/withdraw-bank-balance/${id}`,
      data: data,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }


  getActiveBank(user, serach) {
    const noSpacesSerach = serach?.replace(/\s+/g, "");
    return axios({
      method: "get",
      url: `${API_HOST}/api/get-Active-bank?search=${noSpacesSerach}`,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

  getBankStatement(user, id, filter, page, pageSize) {
    return axios({
      method: "post",
      url: `${API_HOST}/api/admin/manual-user-bank-account-summary/${id}?page=${page}&pageSize=${pageSize}`,
      data: { filters: filter },
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

  permissionRenewBank(data, id, user) {
    return axios({
      method: "put",
      url: `${API_HOST}/api/bank/edit-request/${id}`,
      data: data,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

  searchBankList(user, search) {
    return axios({
      method: "get",
      url: `${API_HOST}/api/admin/bank-name/?search=${search}`,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

  bankTobankTransfer(data, user) {
    return axios({
      method: "post",
      url: API_HOST + "/api/admin/bank-to-bank-transfer",
      data: data,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

    getBankToBankTransferRequest(data, user , page , limit) {
    return axios({
      method: "post",
      url: `${API_HOST}/api/admin/bank-to-bank-transfer-request?page=${page}&pageSize=${limit}`,
      data: data,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

    approveRejecttransferRequest( user ,data, id) {
    return axios({
      method: "post",
      url: `${API_HOST}/api/admin/approve-bank-status/${id}`,
      data: data,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

    getBankAllRequest( user , page , limit , search="" , type="") {
    return axios({
      method: "get",
      url: `${API_HOST}/api/admin/get-all-bank-request?page=${page}&pageSize=${limit}&search=${search}&type=${type}`,
      // data: data,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

    bankRequestApproveReject( user ,data ) {
    return axios({
      method: "post",
      url: `${API_HOST}/api/approve-bank`,
      data: data,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

}



export default new Bank_Service();
